/** Default parser options exposed in the task pane UI. */
export const DEFAULT_PARSER_CONFIG = {
  skipAttributes: true,
  skipDeclaration: true,
  skipComment: true,
  skipNsPrefix: true,
  parseNumbers: true,
  parseBooleans: true,
  trimValues: true,
  maxNestedTags: null,
  attributePrefix: "@_",
};

export const VALUE_PARSER_OPTIONS = [
  { key: "parseNumbers", label: "Parse numbers", parser: "number" },
  { key: "parseBooleans", label: "Parse booleans", parser: "boolean" },
  { key: "trimValues", label: "Trim whitespace", parser: "trim" },
];
